var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap giftPop",
      staticStyle: { top: "150px", width: "580px" },
    },
    [
      _c(
        "win-layer-pop",
        { staticClass: "infoPop" },
        [
          _vm.infoComponent
            ? _c(_vm.infoComponent, {
                tag: "component",
                attrs: { "parent-info": _vm.parentSubInfo },
                on: { close: _vm.closeInfoPopup },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("form", { attrs: { id: "mailFrm" } }, [
        _c("div", { staticClass: "popup_cont" }, [
          _c("h1", { staticClass: "page_title" }, [
            _vm._v(_vm._s(_vm.$t("msg.COUP100.034"))),
          ]),
          _c(
            "div",
            { staticClass: "content_box", staticStyle: { height: "100%" } },
            [
              _c(
                "table",
                {
                  staticClass: "tbl_list",
                  staticStyle: { border: "0px" },
                  attrs: { id: "frm" },
                },
                [
                  _c("tbody", [
                    _c("tr", { staticStyle: { height: "40px" } }, [
                      _c(
                        "th",
                        {
                          staticStyle: {
                            "text-align": "left",
                            border: "0px",
                            width: "150px",
                            "font-size": "large",
                            "background-color": "white",
                            color: "black",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("msg.COUP100.039")))]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "text-align": "left",
                            border: "0px",
                            "font-size": "large",
                          },
                          attrs: { autocomplete: "off" },
                        },
                        [
                          _vm._v(_vm._s(_vm.couponNm)),
                          _c(
                            "a",
                            {
                              staticClass: "button blue lq",
                              staticStyle: {
                                "font-size": "large",
                                "margin-left": "20px",
                                float: "right",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.RequestMyCoupon(true)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("msg.COUP100.044")))]
                          ),
                        ]
                      ),
                    ]),
                    _c("tr", { staticStyle: { height: "40px" } }, [
                      _c(
                        "th",
                        {
                          staticStyle: {
                            "text-align": "left",
                            "font-size": "large",
                            "background-color": "white",
                            color: "black",
                            "border-top": "0px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("msg.COUP100.040")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.userName,
                            expression: "params.userName",
                          },
                        ],
                        staticStyle: {
                          height: "100%",
                          width: "100%",
                          "margin-top": "4px",
                          "font-size": "larger",
                        },
                        attrs: {
                          autocomplete: "off",
                          id: `name`,
                          type: "text",
                        },
                        domProps: { value: _vm.params.userName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.params,
                              "userName",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("tr", { staticStyle: { height: "40px" } }, [
                      _c(
                        "th",
                        {
                          staticStyle: {
                            "text-align": "left",
                            "font-size": "large",
                            "background-color": "white",
                            color: "black",
                            "border-top": "0px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("msg.COUP100.041")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.userTelNo,
                            expression: "params.userTelNo",
                          },
                        ],
                        staticStyle: {
                          height: "100%",
                          width: "100%",
                          "margin-top": "4px",
                          "font-size": "larger",
                        },
                        attrs: { autocomplete: "off", id: `tel`, type: "text" },
                        domProps: { value: _vm.params.userTelNo },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.params,
                              "userTelNo",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("tr", { staticStyle: { height: "40px" } }, [
                      _c(
                        "th",
                        {
                          staticStyle: {
                            "text-align": "left",
                            "font-size": "large",
                            "background-color": "white",
                            color: "black",
                            "border-top": "0px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("msg.COUP100.042")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.userAddr,
                            expression: "params.userAddr",
                          },
                        ],
                        staticStyle: {
                          height: "100%",
                          width: "100%",
                          "margin-top": "4px",
                          "font-size": "larger",
                        },
                        attrs: {
                          autocomplete: "off",
                          id: `addr`,
                          type: "text",
                        },
                        domProps: { value: _vm.params.userAddr },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.params,
                              "userAddr",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "center" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.params.agreeYn,
                    expression: "params.agreeYn",
                  },
                ],
                attrs: {
                  id: "agreeYn",
                  type: "checkbox",
                  "true-value": "1",
                  "false-value": "0",
                },
                domProps: {
                  checked: Array.isArray(_vm.params.agreeYn)
                    ? _vm._i(_vm.params.agreeYn, null) > -1
                    : _vm._q(_vm.params.agreeYn, "1"),
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.params.agreeYn,
                      $$el = $event.target,
                      $$c = $$el.checked ? "1" : "0"
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.params, "agreeYn", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.params,
                            "agreeYn",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.params, "agreeYn", $$c)
                    }
                  },
                },
              }),
              _c("label", { attrs: { for: "agreeYn" } }, [
                _c(
                  "h1",
                  {
                    staticStyle: {
                      "font-size": "large",
                      "text-align": "center",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("msg.COUP100.043")))]
                ),
              ]),
              _c(
                "h1",
                {
                  staticStyle: {
                    "font-size": "large",
                    "margin-top": "11px",
                    color: "blue",
                    "text-decoration": "underline",
                    cursor: "pointer",
                  },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openInfoPopup("KmtcCouponPersonInfoPop")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("msg.COUP100.062")))]
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }